// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"08d2759b","453":"adf6fb03"}[chunkId] + ".chunk.js";
};